import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PasswordRecoveryApplicationEnum } from 'services/ApiService/PasswordRecoveryService/types';

import { Container, Illustration, Information, Title, Description, Button } from '../../PasswordRecovery.styles';

export const CheckEmail: React.FC = () => {
  const history = useHistory();
  const location = useLocation().search;

  const getEmailFromUrl = (): string | null => {
    const query = new URLSearchParams(location);
    return query.get('email');
  };

  const getPasswordRecoveryApplication = (): PasswordRecoveryApplicationEnum => {
    const query = new URLSearchParams(location);
    const passwordRecoveryApp = query.get('passwordRecoveryApplication');
    return passwordRecoveryApp === 'CAP' ? 'CAP' : 'KITE';
  };

  const isCapPasswordRecoveryApplication = (): boolean => {
    return getPasswordRecoveryApplication() === 'CAP';
  };

  return (
    <Container data-testid="password-recovery-check">
      <Illustration />
      <Information>
        <Title>Cheque seu email</Title>
        <Description>
          Verifique o endereço <b>{getEmailFromUrl()}</b>. Certifique-se de olhar a lixeira ou a pasta de spam se o
          email não for encontrado.
        </Description>
        <Description>
          O link de recuperação expira em <b>10 minutos</b>.
        </Description>

        {isCapPasswordRecoveryApplication() ? (
          <Description data-testid="cap-infotext">
            Se mesmo assim você não conseguir recuperar sua senha, entre em contato através do endereço{' '}
            <b>suporte@abletech.info</b>, informando o nome de usuário e um endereço de email válido.
          </Description>
        ) : (
          <Button
            testID="back-login"
            fullWidth={true}
            size="large"
            text="VOLTAR AO LOGIN"
            type="button"
            onClick={(): void => history.push('/login')}
          />
        )}
      </Information>
    </Container>
  );
};
